export default __webpack_public_path__ + "static/media/bf.0593cf08.svg";